import supabase from "../../../shared/database/supabase";
import { CustomError } from "../../../shared/error/error";

export interface UpdateInvoiceRequest {
  id: string;
}

export interface UpdateInvoiceResponse {
  id: string;
}

export const updateInvoiceReq = async (req: UpdateInvoiceRequest): Promise<UpdateInvoiceResponse | Error> => {
  try {
    const { data, error } = await supabase.functions.invoke("update-invoice", {
      body: JSON.stringify({ ...req })
    });

    if (error) throw error;
    if (data.error) throw data.error;

    return data;
  } catch (err) {
    const apiError = err as CustomError;
    console.error(`API Error: ${apiError.message}`);

    if (apiError && apiError.code && apiError.message && apiError.toast_message && apiError.http_status_code) {
      throw new CustomError(apiError);
    }

    throw new CustomError({});
  }
};
